import { Grid2X2, LogOut, User, TrendingDown } from 'lucide-react'

import { logoIconUrl, logoUrl } from '../../assets/clinicAssets'

export default function Sidebar({ activeTab, onChange, onLogout }) {
  return (
    <aside className="fixed inset-y-0 left-0 z-20 hidden w-[240px] overflow-hidden border-r border-[#EEE8DF] bg-white lg:block">
      <div className="flex h-full flex-col px-3 py-6">
        <div className="mb-6 flex justify-center px-4">
          <img
            alt="Odonto Clinic"
            className="h-16 w-48 object-contain"
            src={logoUrl}
          />
        </div>

        <nav className="grid gap-2">
          <NavItem
            icon={Grid2X2}
            isActive={activeTab === 'dashboard'}
            label="Dashboard"
            onClick={() => onChange('dashboard')}
          />
          <NavItem
            icon={User}
            isActive={activeTab === 'patients'}
            label="Pacientes"
            onClick={() => onChange('patients')}
          />
          <NavItem
            icon={TrendingDown}
            isActive={activeTab === 'expenses'}
            label="Saídas"
            onClick={() => onChange('expenses')}
          />
        </nav>

        <div className="mt-auto border-t border-[#EEE8DF] px-4 pt-5">
          <div className="grid grid-cols-[40px_minmax(0,1fr)_32px] items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-white">
              <img
                alt="Ícone da clínica"
                className="h-full w-full object-contain"
                src={logoIconUrl}
              />
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate whitespace-nowrap text-[13px] font-bold leading-5 text-[#1A1A1A]">
                Dra. Gleice
              </p>
              <p className="truncate text-xs font-semibold text-[#5A5147]">Odontologia</p>
            </div>
            <button
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[#5A5147] transition hover:bg-[#F8E1E7] hover:text-[#1A1A1A]"
              type="button"
              aria-label="Sair"
              title="Sair"
              onClick={onLogout}
            >
              <LogOut size={16} strokeWidth={2.3} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </aside>
  )
}

function NavItem({ icon: Icon, isActive, label, onClick }) {
  return (
    <button
      className={`flex h-11 items-center gap-3 rounded-lg px-4 text-sm font-bold transition ${
        isActive
          ? 'bg-[#F8E1E7] text-[#5A5147]'
          : 'text-[#5A5147] hover:bg-[#FBF8F4] hover:text-[#1A1A1A]'
      }`}
      type="button"
      onClick={onClick}
    >
      <Icon size={18} strokeWidth={2.4} aria-hidden="true" />
      <span>{label}</span>
    </button>
  )
}
